/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Common_Filter_Remove_ChipInputs */

const vi_common_filter_remove_chip = /** @type {(inputs: Common_Filter_Remove_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bỏ lọc ${i?.label}`)
};

/**

* @param {Common_Filter_Remove_ChipInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_filter_remove_chip = /** @type {((inputs: Common_Filter_Remove_ChipInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Filter_Remove_ChipInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_filter_remove_chip(inputs)
});